module.exports = __webpack_public_path__ + "img/myreligion_logo.ff9a9d47.svg";